import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import type { Book } from '../../../../shared/types/index.js';

interface BulkImportSuccessViewProps {
  count: number;
  books: Book[];
  userRole?: string;
  onReset: () => void;
  onClose: () => void;
}

export const BulkImportSuccessView: React.FC<BulkImportSuccessViewProps> = ({
  count,
  books,
  userRole,
  onReset,
  onClose,
}) => {
  return (
    <div className="py-8 flex flex-col items-center justify-center text-center max-w-lg mx-auto space-y-4">
      <div className="w-16 h-16 rounded-full bg-emerald-50 border border-emerald-100 flex items-center justify-center text-emerald-600 shadow-xs animate-bounce">
        <CheckCircle2 className="w-8 h-8" />
      </div>
      <div>
        <h3 className="text-lg font-bold text-slate-900">Impor Massal Sukses Terdaftar!</h3>
        <p className="text-sm text-slate-600 mt-1 leading-relaxed">
          Sebanyak <b>{count} buku baru</b> telah berhasil dibuat, divalidasi, dan dimasukkan ke katalog UIBN Anda. Kode Universal Indonesian Book Number (UIBN) telah otomatis digenerate dan dikaitkan untuk masing-masing buku.
        </p>
      </div>

      {/* List of generated UIBN items */}
      <div className="w-full border border-slate-200/80 bg-slate-50 rounded-2xl p-4 text-left space-y-2.5 max-h-56 overflow-y-auto shadow-2xs">
        <p className="text-xs font-bold text-slate-700 flex items-center justify-between border-b border-slate-200/80 pb-1.5">
          <span>Daftar Buku Terdaftar Baru:</span>
          <span className="text-[10px] bg-indigo-50 border border-indigo-100 text-indigo-700 px-1.5 py-0.5 rounded-sm uppercase tracking-wide">
            {userRole === 'admin' ? 'Status: Disetujui' : 'Status: Pengajuan'}
          </span>
        </p>
        <div className="divide-y divide-slate-100 text-[11px] space-y-1.5">
          {books.map((b, idx) => (
            <div key={`${b.id || b.uibn}-${idx}`} className="pt-1.5 first:pt-0 flex items-center justify-between gap-3">
              <div className="truncate">
                <p className="font-bold text-slate-900 truncate">{b.title}</p>
                <p className="text-slate-500 text-[10px]">Penulis: {b.authorName} • {b.category}</p>
              </div>
              <span className="font-mono text-[10px] bg-indigo-50 px-2 py-0.5 rounded text-indigo-700 font-bold tracking-tight">
                {b.uibn}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 pt-3 w-full justify-center">
        <button
          type="button"
          onClick={onReset}
          className="px-5 py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-700 font-semibold rounded-xl text-xs sm:text-sm transition flex-1 cursor-pointer"
        >
          Impor File Lainnya
        </button>
        <button
          type="button"
          onClick={onClose}
          className="px-6 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-xl text-xs sm:text-sm shadow-md transition flex-1 cursor-pointer"
        >
          Selesai & Tutup
        </button>
      </div>
    </div>
  );
};
